/**
 * TopicBar — "what people ask about most" row: label + pct + progress bar.
 * Tints cycle through brand tokens. Brand tokens only.
 */
interface TopicBarProps {
  label: string;
  /** Percentage 0-100 */
  pct: number;
  /** Tailwind bg class for the fill (defaults to genie-primary) */
  fillClassName?: string;
  className?: string;
}

export const TopicBar = ({ label, pct, fillClassName = "bg-genie-primary", className }: TopicBarProps) => {
  return (
    <div className={`flex flex-col gap-1.5 ${className ?? ""}`}>
      <div className="flex items-center justify-between">
        <span className="text-[13.5px] font-medium text-[#222B45]">{label}</span>
        <span className="text-[13px] font-bold text-gray-500">{pct}%</span>
      </div>
      <div className="w-full h-2 rounded-full bg-gray-100 overflow-hidden">
        <div className={`h-full rounded-full ${fillClassName}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};

/** Cycle of brand-token fills for stacked TopicBars. */
export const TOPIC_FILLS = [
  "bg-genie-primary",
  "bg-genie-secondary",
  "bg-genie-accent",
  "bg-genie-info",
  "bg-gray-300",
];

export default TopicBar;
